export interface UnshareArtifactRequest {
  publicId: string
  userIds: string[]
}
